'use strict';

module.exports = Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_filter_by_type'),
    viewClass: require('../modules/views/accommodation_filter_by_type'),
});
